<template>
  <div class="phrase">
    <div class="player">
      <ChappeAnimation v-if="gameName == 'chappe'" :steps="currentPhrase.steps" />
      <BaudotAnimation v-if="gameName == 'baudot'" :code="currentPhrase.code" />
      <MorseAnimation v-if="gameName == 'morse'" :video="currentPhrase.video" />
    </div>

    <h2 class="game-information">
      Entrez la phrase décodée,
      <span v-if="gameName != 'chappe'">lettre par lettre</span
      ><span v-else>mot par mot</span> :
    </h2>
    <div class="words">
      <p v-if="gameName == 'chappe'">(début)</p>
      <div
        class="word"
        v-for="(word, indexWord) in phraseToDecoded"
        :key="indexWord"
        :style="getWordStyle(word)"
      >
        <div class="letterToDecoded" v-if="gameName != 'chappe'">
          <input
            type="text"
            :ref="'letter' + indexWord + indexLetter"
            v-for="(letter, indexLetter) in word"
            :key="indexLetter"
            maxlength="1"
            v-model="phraseToVerif[indexWord + '' + indexLetter]"
            @input="inputLetter($event, indexWord, indexLetter)"
          />
        </div>
        <div v-else class="wordToDecoded">
          <input
            type="text"
            :id="'mot' + indexWord"
            :ref="'mot' + indexWord"
            :key="indexWord"
            v-model="phraseToVerif[indexWord]"
          />
        </div>
        <label :for="'mot' + indexWord">Mot {{ indexWord + 1 }}</label>
      </div>
      <p v-if="gameName == 'chappe'">(fin)</p>
    </div>
    <ActionsGames
      @verification="verification()"
      @showResponse="showResponse()"
      :message="message"
    />
  </div>
</template>

<script>
import ActionsGames from "../layout/ActionsGames";
import ChappeAnimation from "@/components/morse-chappe-baudot/ChappeAnimation";
import BaudotAnimation from "@/components/morse-chappe-baudot/BaudotAnimation";
import MorseAnimation from "@/components/morse-chappe-baudot/MorseAnimation";

export default {
  name: "Phrase",
  components: {
    MorseAnimation,
    BaudotAnimation,
    ActionsGames,
    ChappeAnimation
  },
  props: {
    currentPhrase: {},
    gameName: String,
  },
  data: () => ({
    message: "",
    phraseToVerif: [],
    phraseToDecoded: [],
    showModal: false,
  }),
  created() {
    this.init();
  },
  watch: {
    currentPhrase: function () {
      this.init();
    },
  },
  methods: {
    verification() {
      var indexWord = 0;

      for (var mot of this.phraseToDecoded) {
        if (this.gameName == "chappe") {
          if (
            !this.phraseToVerif[indexWord] ||
              this.strNoAccent(this.phraseToVerif[indexWord].toLowerCase()) != this.strNoAccent(mot)
          ) {
            return (this.message =
              "<h2>Oups, dommage...</h2><h3>Retentez votre chance !</h3>");
          }
        } else {
          var indexLetter = 0;
          for (var letter of mot) {
            if (
              !this.phraseToVerif[indexWord + "" + indexLetter] ||
                this.strNoAccent(this.phraseToVerif[indexWord + "" + indexLetter].toLowerCase()) !=
                this.strNoAccent(letter)
            ) {
              return (this.message =
                "<h2>Oups, dommage...</h2><h3>Retentez votre chance !</h3>");
            }
            indexLetter++;
          }
        }
        indexWord++;
      }
      this.message = this.currentPhrase.solution
        ? "<h3>Réponse : " +
          this.currentPhrase.solution +
          " (" +
          this.currentPhrase.phrase +
          ")</h3>"
        : "<h3>Réponse : " + this.currentPhrase.phrase + "</h3>";
      this.message += "<h3><h2>Bravo, bonne réponse !</h2><h3>Rejouez avec une autre phrase !</h3>"
      return this.message
    },
    showResponse() {
      this.message = this.currentPhrase.solution ? "<h3>Réponse : " +this.currentPhrase.solution +" (" +this.currentPhrase.phrase +")</h3>"
        : "<h3>Réponse : " + this.currentPhrase.phrase + "</h3>";
      this.message +=
        "<h2>Petit joueur...</h2><h3>Rejouez et tentez de décoder une autre phrase !</h3>";
      return this.message;
    },
    init() {
      this.phraseToDecoded = this.currentPhrase.phrase.split(" ");
      this.phraseToVerif = [];
      this.message = "";
      if (this.gameName != "chappe") {
        var index = 0;
        for (var word of this.phraseToDecoded) {
          this.phraseToDecoded[index] = word.split("");
          index++;
        }
      }
    },
    strNoAccent(a) {
      var b = "áàâäãåçéèêëíïîìñóòôöõúùûüýÁÀÂÄÃÅÇÉÈÊËÍÏÎÌÑÓÒÔÖÕÚÙÛÜÝ",
        c = "aaaaaaceeeeiiiinooooouuuuyAAAAAACEEEEIIIINOOOOOUUUUY",
        d = "";
      for (var i = 0, j = a.length; i < j; i++) {
        var e = a.substr(i, 1);
        d += b.indexOf(e) !== -1 ? c.substr(b.indexOf(e), 1) : e;
      }
      return d.toLowerCase();
    },
    getWordStyle(word) {
      if(typeof word !== 'string') {
        return {
          flex: word.length
        }
      }
      return {}
    },
    inputLetter(event, indexWord, indexLetter) {
      console.log(event, indexWord, indexLetter);
      if(event.target.value != '') {
        indexLetter++
        console.log(this.phraseToDecoded[indexWord]);
        if(this.phraseToDecoded[indexWord] && this.phraseToDecoded[indexWord].length <= indexLetter) {
          indexLetter = 0
          indexWord++
        }
        const input = this.$refs['letter' + indexWord + indexLetter]
        if(input) {
          input.focus()
        }
      }
    }
  },
};
</script>

<style lang="scss">
.phrase {
  .game-information {
    text-align: left;
  }
  .words {
    display: flex;
    align-items: flex-start;
    p {
      flex: 1;
      border-bottom: 1px solid #000;
      margin: 0;
      margin-right: 1.5rem;
      font-size: 18px;
      padding: 6px 0;
      height: 42px;
      box-sizing: border-box;

      &:last-child {
        margin-right: 0;
      }
    }
    .word {
      flex: 1;
      margin-right: 1.5rem;

      &:last-child {
        margin-right: 0;
      }

      input {
        border: 1px solid #FFF;
        border-bottom: 1px solid #000;
        width: 100%;
        margin-bottom: 5px;
        font-size: 24px;
        padding: 6px 0;
        text-align: center;
        line-height: 1;

        &:focus {
          outline: none;
          border: 1px solid #000;
        }
      }

      .letterToDecoded {
        display: flex;

        input {
          &:not(:last-child) {
            margin-right: 6px;
          }
        }
      }
    }
  }
  .player {
    position: relative;
    width: 100%;
    border: 10px solid black;
    display: block;
    box-sizing: border-box;
    padding-bottom: 40px;

    &:before {
      content: '';
      display: block;
      width: 100%;
      padding-bottom: 70%;
    }
  }
  audio {
    margin-bottom: 3rem;
  }


  @media (max-width: 800px) {
    .words {
      p {
        font-size: 16px;
        height: 32px;
      }

      .word {
        input {
          font-size: 16px;
        }
      }
    }
  }
}
</style>